export const useGlobalStore = defineStore('global', {
    state: () => ({
        isMobile: false
    }),
    actions: {
        updateWindowSize() {
            const width = window.innerWidth;
            this.isMobile = width < 992;
        },

        queryStringByName(name, url) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url.toLowerCase());
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        },

        noorlibLink(noorlibId, volume, page) {
            return `https://noorlib.ir/fa/book/view/${noorlibId}?volumeNumber=${volume}&pageNumber=${page}`
        },
        
        noorlibLinkOldBase(noorlibId, volume, page) {
            return `https://www.noorlib.ir/View/fa/Book/BookView/Text/${noorlibId}/${volume}/${page}`
        },

        ayahUrl(lang,surahId, ayahNum, useCase) {
            if (useCase === undefined || useCase === null || useCase.length === 0)
                useCase = 'translate';

            let url = '/' + lang + '/ayah' + `/${surahId}/${ayahNum}/${useCase}`
            //console.log(url)
            return url;
        },
    },
})